import { lazy, Suspense } from 'react'
import { Navigate, Routes, Route, useParams } from 'react-router-dom'
import MainLayout from './layouts/MainLayout'
import AuthLayout from './layouts/AuthLayout'
import { LoadingSkeleton } from './components/ui/LoadingSkeleton'

const HomePage = lazy(() => import('./pages/HomePage'))
const JobList = lazy(() => import('./pages/JobList'))
const JobDetail = lazy(() => import('./pages/JobDetail'))
const EnterpriseList = lazy(() => import('./pages/EnterpriseList'))
const EnterpriseDetail = lazy(() => import('./pages/EnterpriseDetail'))
const SchoolList = lazy(() => import('./pages/SchoolList'))
const SchoolDetail = lazy(() => import('./pages/SchoolDetail'))
const TalentList = lazy(() => import('./pages/TalentList'))
const TalentDetail = lazy(() => import('./pages/TalentDetail'))
const JobFairList = lazy(() => import('./pages/JobFairList'))
const JobFairDetail = lazy(() => import('./pages/JobFairDetail'))
const PolicyList = lazy(() => import('./pages/PolicyList'))
const PolicyDetail = lazy(() => import('./pages/PolicyDetail'))
const NoticeList = lazy(() => import('./pages/NoticeList'))
const NoticeDetail = lazy(() => import('./pages/NoticeDetail'))
const EntrepreneurshipList = lazy(() => import('./pages/EntrepreneurshipList'))
const EntrepreneurshipDetail = lazy(() => import('./pages/EntrepreneurshipDetail'))
const ExhibitionHandbook = lazy(() => import('./pages/ExhibitionHandbook'))
const HandbookEnterpriseDetail = lazy(() => import('./pages/handbook/EnterpriseDetail'))
const HandbookSchoolDetail = lazy(() => import('./pages/handbook/SchoolDetail'))
const LoginPage = lazy(() => import('./pages/LoginPage'))
const RegisterPage = lazy(() => import('./pages/RegisterPage'))
const PersonalCenter = lazy(() => import('./pages/PersonalCenter'))
const AboutPage = lazy(() => import('./pages/AboutPage'))
const DataScreen = lazy(() => import('./pages/DataScreen'))

const fallback = <LoadingSkeleton count={3} />

function LegacySchoolDetailRedirect() {
  const { id } = useParams<{ id: string }>()
  return <Navigate to={`/edu/${id || ''}`} replace />
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* 主布局（Header + Footer） */}
      <Route element={<MainLayout />}>
        <Route index element={<Suspense fallback={fallback}><HomePage /></Suspense>} />
        <Route path="jobs" element={<Suspense fallback={fallback}><JobList /></Suspense>} />
        <Route path="jobs/:id" element={<Suspense fallback={fallback}><JobDetail /></Suspense>} />
        <Route path="enterprise" element={<Suspense fallback={fallback}><EnterpriseList /></Suspense>} />
        <Route path="enterprise/:id" element={<Suspense fallback={fallback}><EnterpriseDetail /></Suspense>} />
        <Route path="edu" element={<Suspense fallback={fallback}><SchoolList /></Suspense>} />
        <Route path="edu/:id" element={<Suspense fallback={fallback}><SchoolDetail /></Suspense>} />
        <Route path="school" element={<Navigate to="/edu" replace />} />
        <Route path="school/:id" element={<LegacySchoolDetailRedirect />} />
        <Route path="talent" element={<Suspense fallback={fallback}><TalentList /></Suspense>} />
        <Route path="talent/:id" element={<Suspense fallback={fallback}><TalentDetail /></Suspense>} />
        <Route path="jobfair" element={<Suspense fallback={fallback}><JobFairList /></Suspense>} />
        <Route path="jobfair/:id" element={<Suspense fallback={fallback}><JobFairDetail /></Suspense>} />
        <Route path="policy" element={<Suspense fallback={fallback}><PolicyList /></Suspense>} />
        <Route path="policy/:id" element={<Suspense fallback={fallback}><PolicyDetail /></Suspense>} />
        <Route path="notice" element={<Suspense fallback={fallback}><NoticeList /></Suspense>} />
        <Route path="notice/:id" element={<Suspense fallback={fallback}><NoticeDetail /></Suspense>} />
        <Route path="entrepreneurship" element={<Suspense fallback={fallback}><EntrepreneurshipList /></Suspense>} />
        <Route path="entrepreneurship/:id" element={<Suspense fallback={fallback}><EntrepreneurshipDetail /></Suspense>} />
        <Route path="about" element={<Suspense fallback={fallback}><AboutPage /></Suspense>} />
        <Route path="profile" element={<Suspense fallback={fallback}><PersonalCenter /></Suspense>} />
      </Route>

      {/* 认证布局（左右分屏） */}
      <Route element={<AuthLayout />}>
        <Route path="login" element={<Suspense fallback={fallback}><LoginPage /></Suspense>} />
        <Route path="register" element={<Suspense fallback={fallback}><RegisterPage /></Suspense>} />
      </Route>

      <Route path="handbook" element={<Suspense fallback={fallback}><ExhibitionHandbook /></Suspense>} />
      <Route path="handbook/enterprise/:id" element={<Suspense fallback={fallback}><HandbookEnterpriseDetail /></Suspense>} />
      <Route path="handbook/school/:id" element={<Suspense fallback={fallback}><HandbookSchoolDetail /></Suspense>} />
      <Route path="data-screen" element={<Suspense fallback={fallback}><DataScreen /></Suspense>} />
    </Routes>
  )
}
